import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';

var bgimage = require('./../../images/background/bg-site.png');

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.currentstate = {logo: require('./../../images/logo-dark.png')};
    }
    
    updateFooterLogo = (updatedlogo) => {this.currentstate.logo = updatedlogo;}

    render() {
        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide">
                    <div className="container call-to-action-wrap bg-no-repeat bg-center" style={{ backgroundImage: 'url('+bgimage+')' }}>
                        <div className="p-a30 bg-primary">
                            <div className="row">
                                <div className="col-md-8 col-sm-8">
                                    <div className="call-to-action-left text-black">
                                        <h4 className="text-uppercase m-b10 m-t0">Subscribe to our newsletter!</h4>
                                        <span>Sign Up for Our Newsletter and Never Miss an Update.</span>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-4">
                                    <div className="call-to-action-right">
                                        <div className="widget_newsletter">
                                            <div className="newsletter-bx">
                                                <form role="search" action="./">
                                                    <div className="input-group">
                                                        <input name="news-letter" className="form-control" placeholder="ENTER YOUR EMAIL" type="text" />
                                                        <span className="input-group-btn">
                                                            <button type="submit" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                                                        </span>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="widget widget_about">
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"./"}><img src={this.currentstate.logo} alt="" /></NavLink>
                                        </div>
                                        <p className="max-w400">QTO International partners with contractors globally, providing precise takeoff services to streamline project planning. With successful projects across residential, commercial, and industrial sectors, we bring expertise to every phase of construction.</p>
                                        <ul className="social-icons mt-social-links">
                                            <li><NavLink to={"#"} className="fa fa-linkedin" /></li>
                                            <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                            <li><NavLink to={"#"} className="fa fa-instagram" /></li>
                                            <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                        </ul>
                                    </div>
                                </div>

                                {/* CONTACT US */}
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="widget widget_address_outer">
                                        <h4 className="widget-title">Contact Us</h4>
                                        <ul className="widget_address">
                                            <li><a href='mailto:info@qto.international' style={{ textDecoration: 'none', color: "#999" }}>info@qto.international</a></li>
                                            <li><a href='tel:+44 744 877 2523' style={{ textDecoration: 'none', color: "#999" }}>+44 744 877 2523 </a></li>
                                        </ul>
                                    </div>
                                </div>

                                {/* USEFUL LINKS */}
                                <div className="col-lg-4 col-md-4 col-sm-12 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h4 className="widget-title">Useful links</h4>
                                        <ul>
                                            <li><NavLink to={"/about"}>About</NavLink></li>
                                            <li><NavLink to={"/projects"}>Projects</NavLink></li>
                                            <li><NavLink to={"/contactus"}>Contact Us</NavLink></li>
                                            <li><NavLink to={"/faq"}>FAQ's</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                <div className="mt-footer-bot-center">
                                    <span className="copyrights-text">© 2024 QTO International, All Rights Reserved</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

                <Switcher updateFooterLogo={this.updateFooterLogo.bind(this)} />
            </>
        );
    };
};

export default Footer;
